module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_yoso_studio@3x-3a4c81d4909d0e9f20d95c9d3564c1a0.webp";